import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from 'store';

import DesktopFlightsSearch from 'components/DesktopFlightsSearch';
import { GetAllBillingCompanyResponse } from 'models/billingCompany';
import { TravelArrangerUsersAllowed } from 'services/userService';

type Props = {
  allowedTravelers: TravelArrangerUsersAllowed[];
  isLoadingAllowedTravelers: boolean;
  isLoading?: boolean;
  branchCompanies?: GetAllBillingCompanyResponse[];
  isLoadingBranchCompanies: boolean;
};

const DesktopFlightsSearchContainer = ({
  allowedTravelers,
  isLoadingAllowedTravelers,
  isLoading,
  branchCompanies,
  isLoadingBranchCompanies,
}: Props) => {
  const {
    travelers,
    departurePoint,
    arrivalPoint,
    departureDate,
    returnDate,
    baggageIncluded,
    cabin,
    departureTime,
    returnTime,
    directFlight,
    branchCompany,
    multiDestinationTrips,
    flightStretch,
  } = useSelector((state: RootState) => state.flights);

  return (
    <DesktopFlightsSearch
      defaultTravelers={travelers}
      defaultDeparturePoint={departurePoint}
      defaultArrivalPoint={arrivalPoint}
      defaultDepartureDate={departureDate}
      defaultDepartureTime={departureTime}
      defaultReturnDate={returnDate}
      defaultReturnTime={returnTime}
      defaultBaggageIncluded={baggageIncluded}
      defaultDirectFlight={directFlight}
      defaultCabin={cabin}
      allowedTravelers={allowedTravelers}
      isLoadingAllowedTravelers={isLoadingAllowedTravelers}
      isLoading={isLoading}
      branchCompanies={branchCompanies}
      isLoadingBranchCompanies={isLoadingBranchCompanies}
      defaultBranchCompany={branchCompany}
      defaultMultiDestinationTrips={multiDestinationTrips}
      defaultFlightStretch={flightStretch}
    />
  );
};

export default DesktopFlightsSearchContainer;
